import { useTranslation } from "react-i18next";
import React from "react";
import { Theme, useTheme, Box } from "@mui/material";
import {
  BookingDataConsistencyStatusEnum,
  BookingDataSourceEnum,
} from "@bn/api/apiv1";
import EditIcon from "@icons/myicons/edit.svg?react";
import LinkIcon from "@icons/myicons/links_thin.svg?react";
import ReturnIcon from "@icons/myicons/category_return.svg?react";
import WarningIcon from "@icons/myicons/warning.svg?react";
import DocumentShareArrowIcon from "@icons/myicons/document-file-share-arrow.svg?react";
import { Tooltip } from "@components";

const mapStatusToIcon = (
  status: "edit" | "link" | "returned" | "warning" | "warningDelta" | "csv",
  theme: Theme
) =>
  ({
    edit: (
      <EditIcon color={theme.palette.icon.secondary} width={18} height={18} />
    ),
    link: (
      <LinkIcon color={theme.palette.icon.secondary} width={18} height={18} />
    ),
    returned: (
      <ReturnIcon color={theme.palette.icon.warning} width={18} height={18} />
    ),
    warning: (
      <WarningIcon color={theme.palette.icon.warning} width={18} height={18} />
    ),
    warningDelta: (
      <WarningIcon color={theme.palette.icon.warning} width={18} height={18} />
    ),
    csv: (
      <DocumentShareArrowIcon
        color={theme.palette.icon.secondary}
        width={18}
        height={18}
      />
    ),
  })[status];

const getStatus = (
  isExternalID: boolean,
  dataConsistencyStatus?: BookingDataConsistencyStatusEnum,
  dataSource?: BookingDataSourceEnum
) => {
  if (dataSource === BookingDataSourceEnum.CSV) {
    return "csv";
  }

  if (dataConsistencyStatus === BookingDataConsistencyStatusEnum.EXACT_NOL) {
    return isExternalID ? "link" : "edit";
  }

  if (
    dataConsistencyStatus ===
    BookingDataConsistencyStatusEnum.BOOKING_WITH_NOL_ESTIMATED
  ) {
    return "returned";
  }

  if (
    dataConsistencyStatus ===
    BookingDataConsistencyStatusEnum.NEGATIVE_NOL_DELTA_RESOLUTION
  ) {
    return "warning";
  }

  if (
    dataConsistencyStatus === BookingDataConsistencyStatusEnum.DELTA_RESOLUTION
  ) {
    return "warningDelta";
  }
  return "edit";
};

export const TransactionStatusIcon = ({
  dataConsistencyStatus,
  dataSource,
  isExternalID,
}: {
  dataConsistencyStatus?: BookingDataConsistencyStatusEnum;
  dataSource?: BookingDataSourceEnum;
  isExternalID: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const status = getStatus(isExternalID, dataConsistencyStatus, dataSource);

  return (
    <Tooltip
      title={t(`transactionsTable.status.${status}.title`)}
      text={t(`transactionsTable.status.${status}.text`)}
    >
      <Box display="inline-flex" alignItems="center" sx={{ cursor: "help" }}>
        {mapStatusToIcon(status, theme)}
      </Box>
    </Tooltip>
  );
};
